import { Component, ElementRef, ViewChild, HostListener, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { CognitoService } from '../core/services/cognito.service';
import { Router } from '@angular/router';
import { EventService } from '../features/events/services/event.service';
import {IProgram} from '../features/events/models/program.model';
import { ProgramService } from '../core/services/program.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrl: './app.topbar.component.scss',
})
export class AppTopBarComponent implements OnInit {
  items!: MenuItem[];
  userName: string = '';
  toggleProfileClassState = true;
  toggleNotifyClassState = true;
  showRefreshCookie = false;
  //items!: MenuItem[] = [];
  menuItems: MenuItem[] = [];
  programs: IProgram[] = [];
  selectedProgramId: number = 0;
  showProgramDropdown: boolean = false;
  showSelectProgramModal: boolean = false;

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
  @ViewChild('profileul') profileul!: ElementRef;
  @ViewChild('topbarmenu') menu!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    private readonly cognitoService: CognitoService,
    private readonly router: Router,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private readonly eventService: EventService,
    private programService: ProgramService
  ) {
    this.cognitoService.getUser().then((data: any) => {
      this.userName = data.attributes.name;
      const roleString = data?.attributes?.['custom:role'] || '';
      const roles = roleString.split(',').map((r: string) => r.trim().toLowerCase());

      this.showRefreshCookie = roles.some((role: string) => ['admin', 'ticket_manager', 'ticket_operator'].includes(role));
    });
    this.items = [
      {
        label: '',
        items: [
          {
            label: 'Change Password',
            icon: 'pi pi-user-edit',
            command: () => this.router.navigate(['/change-password']),
          },
          {
            label: 'Logout',
            icon: 'pi pi-upload',
            command: () => this.logout(),
          },
        ],
      },
    ];
  }
  ngOnInit(): void {
    this.programService.programId$.subscribe(id => {
      this.selectedProgramId = id;
    });
    this.programService.programsUpdated$.subscribe(() => {
      this.getPrograms();
    });
    this.getPrograms();
  }

  navigateTo(profile: string) {}

  logout() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to log out?',
      header: 'Log Out Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.cognitoService
          .signOut()
          .then(() => {
            this.programService.setProgramId(0);
            this.clearSignedCookie();
            this.router.navigate(['/auth/login']);
          })
          .catch((error) => {
            const customMessage = this.getCognitoErrorMessage(error.code, 'Failed to process the request. Please try again.');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: customMessage });
          });
      },
      reject: () => {},
    });
  }
  RefreshCookie() {
    this.clearSignedCookie();
    this.eventService.setSignedCookie();
    //window.open('https://download.admin.dev.ticket-bangla.com', '_blank');
  }
  clearSignedCookie() {
    const expireCookie = (name: string) => {
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    };

    expireCookie('CloudFront-Policy');
    expireCookie('CloudFront-Signature');
    expireCookie('CloudFront-Key-Pair-Id');
  }

  toggleProfile(event: Event): void {
    event.stopPropagation();
    this.toggleProfileClassState = !this.toggleProfileClassState;

    if (!this.toggleNotifyClassState) {
      this.toggleNotifyClassState = true;
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdownOnClickOutside(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    if (
      this.profileul &&
      this.menuButton &&
      !this.profileul.nativeElement.contains(clickedElement) &&
      !this.menuButton.nativeElement.contains(clickedElement)
    ) {
      this.toggleProfileClassState = true;
    }
  }

  getCognitoErrorMessage(errorCode: string, defaultMessage: string = 'An unexpected error occurred. Please try again.'): string {
    switch (errorCode) {
      case 'CodeMismatchException':
        return 'The OTP you entered is incorrect.';
      case 'ExpiredCodeException':
        return 'The OTP has expired. Please request a new OTP.';
      case 'LimitExceededException':
        return 'Attempt limit exceeded. Please try again later.';
      case 'UserNotFoundException':
        return 'The user does not exist. Please check your phone number.';
      case 'InvalidParameterException':
        return 'Input parameters are invalid.';
      case 'NotAuthorizedException':
        return 'Incorrect username or password.';
      case 'UserNotConfirmedException':
        return 'User is not confirmed. Please confirm your account.';
      case 'InvalidPasswordException':
        return 'The password does not meet the required policy. Please ensure it has the correct length, special characters, and other criteria.';
      default:
        return defaultMessage;
    }
  }

  getPrograms() {
    this.eventService.getAllPrograms().subscribe({
      next: (data: any[]) => {
        if (data && data.length > 0) {
          this.cognitoService.getUser().then((user: any) => {
            const roleString = user?.attributes?.['custom:role'] || '';
            const roles = roleString.split(',').map((r: string) => r.trim().toLowerCase());
            const isSuperAdmin = roles.includes('admin');
            let filteredData = [...data];

            // Filter programs if user is not super admin
            if (!isSuperAdmin) {
              const userProgramIds = user?.attributes?.['custom:program_ids'] || '';
              const allowedProgramIds = userProgramIds
                ? userProgramIds.split(',')
                  .map((id: string) => Number(id.trim()))
                  .filter((id: number) => !isNaN(id))
                : [];

              filteredData = data.filter((program: IProgram) => allowedProgramIds.includes(program.id));
            }

            const sortedData = filteredData.sort((a: any, b: any) => b.id - a.id);

            this.programs = [{ id: 0, name: 'Select a program' } as IProgram, ...sortedData];
            this.showProgramDropdown = true;
            if (this.selectedProgramId == 0) {
              this.showSelectProgramModal = true;
            }
          });
        } else {
          this.programs = [];
          this.showProgramDropdown = false;
        }
      },
      error: (err: any) => {
        console.error('Failed to load programs:', err);
        this.programs = [];
        this.showProgramDropdown = false;
      }
    });
  }


  onProgramChange(event: any) {
    const selectedProgramId = +event.value;
    this.programService.setProgramId(selectedProgramId);

    this.cognitoService.getCurrentUserRoles().then((role: string) => {
      let desireRoute = '/';
      let globalRoute = '/program-management';

      if (role.includes('admin')) {
        desireRoute = '/';
        globalRoute = '/program-management';
      } else if (role.includes('customer_support')) {
        desireRoute = '/issues';
        globalRoute = '/home';
      } else if (role.includes('event_manager') && role.includes('ticket_manager')) {
        desireRoute = '/events';
        globalRoute = '/program-management';
      } else if (role.includes('ticket_manager')) {
        desireRoute = '/events/event-ticket';
        globalRoute = '/program-management';
      } else if (role.includes('ticket_operator')) {
        desireRoute = '/';
        globalRoute = '/home';
      } else if (role.includes('event_manager')) {
        desireRoute = '/events';
        globalRoute = '/program-management';
      }

      const targetRoute = selectedProgramId > 0 ? desireRoute : globalRoute;
      this.router.navigate([targetRoute]);
    });

  }

  private getDefaultRouteForRole(role: string): string {
    if (role.includes('admin')) {
      return '/program-management';
    } else if (role.includes('customer_support')) {
      return '/home';
    } else if (role.includes('event_manager') && role.includes('ticket_manager')) {
      return '/program-management';
    } else if (role.includes('ticket_manager')) {
      return '/home';
    } else if (role.includes('ticket_operator')) {
      return '/home';
    } else if (role.includes('event_manager')) {
      return '/program-management';
    } else {
      return '/home';
    }
  }
}
